
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface NotificationTrendsChartProps {
  chartData: Array<{
    date: string;
    sent: number;
    delivered: number;
    failed: number;
    read: number;
  }>;
}

const NotificationTrendsChart = ({ chartData }: NotificationTrendsChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Notification Trends</CardTitle>
        <CardDescription>Daily notification metrics over time</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="sent" fill="#8884d8" name="Sent" />
              <Bar dataKey="delivered" fill="#82ca9d" name="Delivered" />
              <Bar dataKey="read" fill="#ffc658" name="Read" />
              <Bar dataKey="failed" fill="#ff7c7c" name="Failed" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationTrendsChart;
